export const DEFAULT_EXTERNAL_DOCUMENT_TITLE = 'External Document';

export const ANALYTIC_EVENTS = {
  DELETED_EXTERNAL_DOCUMENT: 'External documents0 deleted document',
  OPENED_EXTERNAL_DOCUMENT: 'External documents0 opened document',
};
